module.exports = __webpack_public_path__ + "static/media/default-redeem.3f9d67cf.jpg";